import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

export const DEFAULT_STEPS = [
  {
    no: "01",
    title: "Select your Finish",
    body: "Begin with the material. Order samples to find the finish that belongs in your space.",
    cta: { label: "Request a Project Consultation", to: "/contact" },
  },
  {
    no: "02",
    title: "Engage an Installer",
    body: "We supply; your chosen installer fits. Not sure where to start? We can point you toward trusted trades who know our materials well.",
    cta: { label: "Get in Touch", to: "/contact" },
  },
  {
    no: "03",
    title: "Enjoy your Finish for Life",
    body: "Natural materials only improve with time. We're here afterwards with care guidance and support, long after delivery.",
    cta: { label: "Contact Us", to: "/contact" },
  },
];

export const PurchaseSteps = ({
  steps = DEFAULT_STEPS,
  eyebrow = "How to Purchase",
  title = "Three steps to your finish.",
}) => (
  <section className="bg-secondary/30" data-testid="how-to-purchase">
    <div className="edge py-20 md:py-28">
      <span className="eyebrow">{eyebrow}</span>
      <h2 className="mt-4 text-3xl font-light tracking-editorial md:text-5xl">{title}</h2>
      <div className="mt-14 grid grid-cols-1 gap-10 md:grid-cols-3">
        {steps.map((s) => (
          <Reveal key={s.no} className="flex flex-col pt-6">
            <span className="eyebrow">{s.no}</span>
            <h3 className="mt-3 text-2xl font-light tracking-editorial">{s.title}</h3>
            <p className="mt-4 flex-1 text-sm leading-relaxed text-muted-foreground">{s.body}</p>
            <Link
              to={s.cta.to}
              className="mt-6 inline-block w-fit border-b border-foreground pb-1 text-sm uppercase tracking-[0.16em]"
            >
              {s.cta.label} →
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
